import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema";

export const VISIT_DETAILS_DOCUMENT_FIELDS = [
  "photograph",
  "passportFront",
  "passportBack",
  "emiratesIdFront",
  "emiratesIdBack",
  "visa",
] as const satisfies readonly (keyof PortSecurityFormData)[];

export type VisitDetailsDocumentField = (typeof VISIT_DETAILS_DOCUMENT_FIELDS)[number];
